import { render, staticRenderFns } from "./zValue.vue?vue&type=template&id=58063384&scoped=true"
import script from "./zValue.vue?vue&type=script&lang=js"
export * from "./zValue.vue?vue&type=script&lang=js"
import style0 from "./zValue.vue?vue&type=style&index=0&id=58063384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58063384",
  null
  
)

export default component.exports